import { AppMenuSheet, type IconName } from '@core/designsystem';

/**
 * Что можно завести глобальной кнопкой «плюс» — «Структура» §11.
 *
 * Скан идёт последним пунктом, но существует без дела: в суде снимают материалы,
 * а не заводят карточки, и дело выбирается после съёмки. В этот перечень он поэтому
 * и не входит: он не открывает экран создания, а сразу снимает.
 */
export type CreateAction = 'case' | 'client' | 'task' | 'event';

const ACTIONS: { action: CreateAction; label: string; icon: IconName }[] = [
  { action: 'case', label: 'Дело', icon: 'folder' },
  { action: 'client', label: 'Клиент', icon: 'person' },
  { action: 'task', label: 'Задача', icon: 'checklist' },
  { action: 'event', label: 'Событие', icon: 'calendar_month' },
];

/**
 * Лист создания. Кнопка «плюс» одна на всё приложение и живёт внизу справа: создание
 * начинается одинаково, где бы юрист ни находился, и дотянуться можно большим пальцем.
 *
 * **Скан открывает камеру прямо отсюда**, а не переходом на экран съёмки. Системное
 * окно камеры Safari открывает только по щелчку в настоящее поле выбора файла: экран,
 * который зовёт камеру у себя в `useEffect`, на iPhone не откроет ничего. Поэтому
 * пункт — поле, а экран быстрого скана получает уже снятый кадр.
 */
export function CreateSheet({
  onDismiss,
  onSelect,
  onScan,
}: {
  onDismiss: () => void;
  onSelect: (action: CreateAction) => void;
  onScan: (photos: File[]) => void;
}) {
  return (
    <AppMenuSheet
      title="Создать"
      onDismiss={onDismiss}
      items={[
        ...ACTIONS.map((item) => ({
          icon: item.icon,
          label: item.label,
          onSelect: () => onSelect(item.action),
        })),
        {
          icon: 'document_scanner' as const,
          label: 'Сканировать документ',
          onSelect: () => undefined,
          picker: {
            accept: 'image/*',
            capture: 'environment' as const,
            multiple: false,
            onFiles: onScan,
          },
        },
      ]}
    />
  );
}
